(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('feasibility-check', {
            parent: 'entity',
            url: '/feasibility-check?page&sort&search',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.feasibilityCheck.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/feasibility-check/feasibility-checks.html',
                    controller: 'FeasibilityCheckController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                		value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feasibilityCheck');
                    $translatePartialLoader.addPart('alertType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('feasibility-check-detail', {
            parent: 'feasibility-check',
            url: '/feasibility-check/{id}',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.feasibilityCheck.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-detail.html',
                    controller: 'FeasibilityCheckDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feasibilityCheck');
                    $translatePartialLoader.addPart('alertType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FeasibilityCheck', function($stateParams, FeasibilityCheck) {
                    return FeasibilityCheck.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'feasibility-check',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('feasibility-check-detail.edit', {
            parent: 'feasibility-check-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-dialog.html',
                    controller: 'FeasibilityCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FeasibilityCheck', function(FeasibilityCheck) {
                            return FeasibilityCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('feasibility-check.new', {
            parent: 'feasibility-check',
            url: '/new',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-dialog.html',
                    controller: 'FeasibilityCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                requestId: null,
                                customerName: null,
                                phone: null,
                                email: null,
                                createDate: null,
                                updateDate: null,
                                notes: null,
                                latitude: null,
                                longitude: null,
                                address: null,
                                notificationType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('feasibility-check', null, { reload: 'feasibility-check' });
                }, function() {
                    $state.go('feasibility-check');
                });
            }]
        })
        .state('feasibility-check.edit', {
            parent: 'feasibility-check',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-dialog.html',
                    controller: 'FeasibilityCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FeasibilityCheck', function(FeasibilityCheck) {
                            return FeasibilityCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('feasibility-check', null, { reload: 'feasibility-check' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('feasibility-check.delete', {
            parent: 'feasibility-check',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-delete-dialog.html',
                    controller: 'FeasibilityCheckDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FeasibilityCheck', function(FeasibilityCheck) {
                            return FeasibilityCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('feasibility-check', null, { reload: 'feasibility-check' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
